import React from 'react';
import { useCartContext } from 'context/CartContext';
import { getCartQuantity } from 'helpers/cartHelpers';
import { ShoppingCartIcon } from '@heroicons/react/solid';
import OrderModal from 'components/OrderModal';
import { useMenuContext } from 'context/MenuContext';

interface Props {
  preview: boolean;
}
const CartIcon: React.FC<Props> = ({ preview }) => {
  const { state } = useCartContext();
  const { features } = useMenuContext();
  const [showDialog, setShowDialog] = React.useState(false);
  const open = () => setShowDialog(true);
  const close = () => setShowDialog(false);

  return (
    <>
      {features === 'CATALOGO' ? null : (
        <>
          <div className="flex gap-1 justify-end">
            <button onClick={open} aria-label="Open Cart" disabled={preview}>
              <ShoppingCartIcon className="h-6 w-6" />
            </button>
            {preview ? null : (
              /* @ts-ignore */
              <div className="text-base">{getCartQuantity(state.products)}</div>
            )}
          </div>
          {preview ? null : (
            <OrderModal showDialog={showDialog} onDismiss={close} />
          )}
        </>
      )}
    </>
  );
};

export default CartIcon;
